import axios from '../../../lib/axios-auth.js';

const state = {
    offers: []
};

const getters = {
    /**
     * Retrieves the offers state.
     * @param {object} state - The vuex state.
     * @returns {*}
     */
    offers: state => {
        return state.offers.listings;
    }
};

const mutations = {
    /**
     * Commits the offers content change.
     * @param {object} state - The vuex state.
     * @param {object} payload - The payload object.
     * @returns {void}
     */
    setOffers: (state, payload) => {
        state.offers = payload;
    }
};

const actions = {
    /**
     * Fetches the offers content.
     * @param {object} context - The vuex context object.
     * @param {function} context.commit - The commit method.
     * @param {object} payload - The commit method.
     * @returns {void}
     */
    getOffers: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/v2/perks-widget/listings/${payload.id}`)
                .then(({ data }) => {
                    commit('setOffers', data);
                    resolve(data);
                }).catch(({ response }) => {
                    reject(response);
                });
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
